import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import GoogleMap from "google-map-react";
import { GOOGLE_MAP_SETTINGS } from "@constants";
import { MapMarker } from "../../../../components";

const LocationMap = forwardRef((props, ref) => {
	const { locationCoordinates } = props;
	return (
		<div
			className="form-map-container"
			ref={ref}
		>
			<GoogleMap
				zoom={15}
				center={{
					lat: parseFloat(locationCoordinates.lat),
					lng: parseFloat(locationCoordinates.lng),
				}}
				bootstrapURLKeys={{ key: GOOGLE_MAP_SETTINGS.key }}
				options={GOOGLE_MAP_SETTINGS}
			>
				<MapMarker
					lat={parseFloat(locationCoordinates.lat)}
					lng={parseFloat(locationCoordinates.lng)}
				/>
			</GoogleMap>
		</div>
	);
});

LocationMap.propTypes = {
	locationCoordinates: PropTypes.object.isRequired,
};

export default LocationMap;
